import { render, staticRenderFns } from "./TeamRow.vue?vue&type=template&id=3cedff89&"
import script from "./TeamRow.vue?vue&type=script&lang=js&"
export * from "./TeamRow.vue?vue&type=script&lang=js&"
import style0 from "./TeamRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports